import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { TOMOS, TOMO_INCLUDES } from '../../data/content';
export function TomosList() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-231" data-mp="1vcorov3q3ls6">
      <div className="mx-auto max-w-3xl" data-id="element-232" data-mp="20b8h55hizfpa">
        <Reveal className="text-center" data-id="element-233" data-mp="20a73qud1eh4e">
          <SectionBadge data-id="element-234" data-mp="13kzilngbya10">Qué incluye</SectionBadge>
          <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-235" data-mp="13maihc6nmxmu">
            Los <span className="u-lime" data-id="element-236" data-mp="17mugehz1y5a1">6 tomos</span> completos
          </h2>
        </Reveal>

        <div className="mt-8 space-y-2.5" data-id="element-237" data-mp="1ckmanin663he">
          {TOMOS.map((tomo, index) => <Reveal key={tomo.n} delay={Math.min(index, 3) * 60} data-id="element-238" data-mp="1hd5wt3zxa6xt" data-mpi={index}>
              <details open={index === 0} className="group overflow-hidden rounded-2xl border border-white/10 bg-ink/90" data-id="element-239" data-mp="jx05i5yamqsf">
                <summary className="flex cursor-pointer list-none items-center gap-3.5 p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lime sm:p-5 [&::-webkit-details-marker]:hidden" data-id="element-240" data-mp="ov1nsonwam2u">
                  <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full font-display text-base text-ink" style={{
                backgroundColor: tomo.color
              }} data-id="element-241" data-mp="2ln7av64msc16">
                    {tomo.n}
                  </span>
                  <span className="flex-1" data-id="element-242" data-mp="26ykl0ahdo1vp">
                    <span className="block text-[10px] font-extrabold uppercase tracking-[0.18em] text-lime" data-id="element-243" data-mp="26vexgzoed823">
                      Tomo {tomo.n}
                    </span>
                    <span className="mt-0.5 block text-sm font-bold leading-snug text-snow sm:text-base" data-id="element-244" data-mp="1xxczkszymvj1">
                      {tomo.title}
                    </span>
                  </span>
                  <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-snow-dim transition-transform duration-300 group-open:rotate-180" aria-hidden="true" data-id="element-245" data-mp="3sam1nzq6fer9" />
                </summary>
                <p className="px-4 pb-4 text-sm leading-relaxed text-snow-muted sm:px-5 sm:pl-[72px]" data-id="element-246" data-mp="f1qap7h00z4g">{tomo.desc}</p>
              </details>
            </Reveal>)}
        </div>

        <Reveal delay={110} className="mt-6" data-id="element-247" data-mp="18qwr9wv7cz0">
          <div className="rounded-2xl border-2 border-lime bg-lime/10 p-5 sm:p-6" data-id="element-248" data-mp="6apzchks65uw">
            <h3 className="font-display text-lg text-lime" data-id="element-249" data-mp="tyzi1amp6dht">Cada tomo incluye</h3>
            <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2" data-id="element-250" data-mp="y0kr0kw427mq">
              {TOMO_INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-medium leading-snug text-snow" data-id="element-251" data-mp="k1l3jgkc3ys5">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-252" data-mp="ozd22tfhij5b" />
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}